import React from 'react';
import { ProductTableType } from '@upstart/harmony/lib/legos/ricForm/ricFormTypes';
import {
  FinanceResponseData,
  FinalProductOrigin,
} from '@upstart/harmony/lib/legos/financingTypes';
import {
  formatCurrency,
  getProductsTotal,
} from '@upstart/harmony/lib/ric-form-utils';
import { SectionItem, SubsectionItem, ProductTable } from '../Components';

const SchemaProductTable = ({
  formElement,
  responseData,
  fetchResponseWithUpdatedData,
  isSubSectionElement,
}: {
  formElement: ProductTableType;
  isSubSectionElement: boolean;
  responseData: FinanceResponseData;
  fetchResponseWithUpdatedData: (data: Partial<FinanceResponseData>) => void;
}) => {
  const {
    title,
    subtitle,
    columns,
    productCategory,
    displayTotalValue,
  } = formElement;

  const products = (responseData?.finalizedProductList ?? []).filter(
    p => productCategory === p.category && p.origin !== FinalProductOrigin.FEE,
  );
  const productsValue = displayTotalValue
    ? formatCurrency(getProductsTotal(products))
    : null;

  const feeProducts = (responseData?.finalizedProductList ?? []).filter(
    p => productCategory === p.category && p.origin === FinalProductOrigin.FEE,
  );
  const feeProductsValue = displayTotalValue
    ? formatCurrency(getProductsTotal(feeProducts))
    : null;

  const HeaderComponent = isSubSectionElement ? SubsectionItem : SectionItem;
  return (
    <>
      {feeProducts.length > 0 && (
        <>
          <HeaderComponent
            title={`${title} (Fees)`}
            subtitle={subtitle}
            value={feeProductsValue}
          />

          <div className="form-subsection">
            <ProductTable
              columns={columns}
              responseData={responseData}
              products={feeProducts}
              onChange={fetchResponseWithUpdatedData}
            />
          </div>
        </>
      )}
      {products.length > 0 && (
        <>
          <HeaderComponent
            title={title}
            subtitle={subtitle}
            value={productsValue}
          />
          <div className="form-subsection">
            <ProductTable
              columns={columns}
              responseData={responseData}
              products={products}
              onChange={fetchResponseWithUpdatedData}
            />
          </div>
        </>
      )}
    </>
  );
};

export default SchemaProductTable;
